(function() {
    var root = document.documentElement;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;
    var t = function(s) { return typeof window.__ === 'function' ? window.__(s) : s; };

    function initRise() {
        var items = document.querySelectorAll('.dl [data-rise]');
        if (!items.length || reduced || !hasIO) return;
        Array.prototype.forEach.call(items, function(el) {
            var sibs = el.parentElement ? el.parentElement.querySelectorAll(':scope > [data-rise]') : [];
            var i = Array.prototype.indexOf.call(sibs, el);
            el.style.setProperty('--dl-i', String(Math.max(0, i) % 6));
        });
        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) {
                    e.target.classList.add('is-in');
                    io.unobserve(e.target);
                }
            });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        root.classList.add('dl-js');
        Array.prototype.forEach.call(items, function(el) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
            else io.observe(el);
        });
    }

    function initPicker() {
        var stage = document.querySelector('[data-dl-stage]');
        if (!stage) return;
        var picks = Array.prototype.slice.call(stage.querySelectorAll('[data-dl-pick]'));
        picks.forEach(function(btn) {
            btn.addEventListener('click', function() {
                var key = btn.getAttribute('data-dl-pick');
                stage.setAttribute('data-body', key);
                picks.forEach(function(b) {
                    b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
                });
            });
        });
    }

    function initStory() {
        var grid = document.querySelector('.dl-lite-grid');
        if (!grid || !hasIO) return;
        var steps = Array.prototype.slice.call(grid.querySelectorAll('[data-dl-step]'));
        if (!steps.length) return;
        function activate(n) {
            grid.setAttribute('data-state', n);
            steps.forEach(function(s) {
                s.classList.toggle('is-active', s.getAttribute('data-dl-step') === n);
            });
        }
        var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) activate(e.target.getAttribute('data-dl-step'));
            });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        steps.forEach(function(s) { io.observe(s); });
        var first = grid.querySelector('.dl-panel-1');
        if (first) first.addEventListener('focusin', function() { activate('1'); });
    }

    function initVideo() {
        var video = document.querySelector('[data-dl-video]');
        var toggle = document.querySelector('[data-dl-video-toggle]');
        if (!video) return;
        var held = reduced;
        function label() {
            if (toggle) toggle.textContent = video.paused ? t('Play video') : t('Pause video');
        }
        function play() {
            var p = video.play();
            if (p && p.catch) p.catch(label);
        }
        video.addEventListener('play', label);
        video.addEventListener('pause', label);
        if (toggle) {
            toggle.addEventListener('click', function() {
                if (video.paused) { held = false; play(); }
                else { held = true; video.pause(); }
            });
            label();
            toggle.hidden = false;
        }
        if (!hasIO) { if (!held) play(); return; }
        new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) { if (!held) play(); }
                else if (!video.paused) video.pause();
            });
        }, { threshold: 0.35 }).observe(video);
    }

    function init() {
        initRise();
        initPicker();
        initStory();
        initVideo();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
